import { render, staticRenderFns } from "./DashboardQuestionWeb.vue?vue&type=template&id=dddff2ac&scoped=true"
import script from "./DashboardQuestionWeb.vue?vue&type=script&lang=ts"
export * from "./DashboardQuestionWeb.vue?vue&type=script&lang=ts"
import style0 from "./DashboardQuestionWeb.vue?vue&type=style&index=0&id=dddff2ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dddff2ac",
  null
  
)

export default component.exports